<template>
  <section>
    <v-layout
      column
      wrap
      align-center
    >
      <v-flex
        xs12
        sm4
        class="my-4">
        <div class="text-center">
          <h2 class="headline font-weight-bold mb-4 text-center text-uppercase">Notre actualité</h2>
          <span class="subheading">
            Venez découvrir la technologie NEWMAT plafond et mur tendus
          </span>
        </div>
      </v-flex>
      <v-flex
        xs12
        class="my-4">
        <v-container grid-list-xl>
          <v-layout
            wrap
            align-center>
            <v-flex
              v-for="(actualite, i) in orderBy(actualites, 'creation')"
              v-if="actualite.publie"
              :key="i"
              sm6
              class="align-self-start">
              <v-card
                flat>
                <v-img
                  :src="actualite.couverture"
                  height="200px"
                  position="center"/>
                <v-card-title
                  primary-title
                  class="layout justify-center">
                  {{ actualite.titre }}
                </v-card-title>
                <v-card-text v-html="actualite.contenu"/>
                <v-card-actions>
                  <v-row
                    align="center"
                    justify="end"
                  >
                    <span class="overline mr-2">du {{ formatedDate(actualite.datestart) }} au {{ formatedDate(actualite.dateend) }}</span>
                  </v-row>
                </v-card-actions>
              </v-card>
            </v-flex>
          </v-layout>
        </v-container>
      </v-flex>
    </v-layout>
  </section>
</template>

<script>
import {
  mapGetters,
  mapActions
} from 'vuex'
import Vue2Filters from 'vue2-filters'
import moment from 'moment'

export default {
  mixins: [Vue2Filters.mixin],
  metaInfo () {
    return {
      title: 'Plafond et mur tendus NEWMAT Annecy'
    }
  },
  data () {
    return {
    }
  },
  computed: {
    ...mapGetters(['actualites'])
  },
  created () {
    this.$store.dispatch('bindActualites')
  },
  methods: {
    ...mapActions(['showModal']),
    formatedDate (datetoformat) {
      return moment(datetoformat).format('DD/MM/YYYY')
    }
  }
}
</script>

<style lang="scss">
</style>
